// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ceeff16c","885":"382080c3"}[chunkId] + ".chunk.js";
};